var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FormWrapper",
    {
      attrs: {
        title: "Credentials",
        body: "Add your credentials, licences, and certifications",
      },
    },
    [
      _c("UIButton", {
        staticClass: "flex justify-end mb-4",
        attrs: { icon: "plus", variant: "black", buttonText: "Add" },
        on: { click: _vm.showModal },
      }),
      _c(
        "LoadingOverlay",
        {
          attrs: {
            hasData: !!_vm.certifications,
            loading: _vm.$apollo.queries.certifications.loading,
            customPlaceholderMessage: "Start adding certifications",
          },
        },
        _vm._l(_vm.certifications, function (certification) {
          return _c("ProfileCertificationCard", {
            key: certification.id,
            staticClass: "mt-4",
            attrs: { certification: certification, userId: _vm.userId },
            on: { updated: _vm.refresh, removed: _vm.refresh },
          })
        }),
        1
      ),
      _vm.isModalOpen
        ? _c("CertificationModal", {
            attrs: { userId: _vm.userId },
            on: { added: _vm.refresh },
            model: {
              value: _vm.isModalOpen,
              callback: function ($$v) {
                _vm.isModalOpen = $$v
              },
              expression: "isModalOpen",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }